import { PlanFieldDev, PlanField } from 'types/plan';
import fetchHandler, { fetchHandlerForm } from './Handler';
interface PlanFieldsUpdate {
	fieldDefinitions: PlanField;
}

export const createPlanField = async (data: PlanFieldDev): Promise<any> => {
	// console.log(body, '------------->');
	try {
		const response = await fetchHandler({
			method: 'POST',
			endpoint: '/plan/plan-structures',
			data,
		});
		if (response) {
			return response;
		}
	} catch (error) {
		console.error('errror showing', error);
		throw error;
	}
};
export const updatePlanField = async (data: PlanFieldsUpdate, id: string): Promise<any> => {
	// console.log(body, '------------->');
	try {
		const response = await fetchHandler({
			method: 'PUT',
			endpoint: `/plan/${id}`,
			data,
		});
		if (response) {
			return response;
		}
	} catch (error) {
		console.error('errror showing', error);
		throw error;
	}
};

export const createPlan = async (body: any): Promise<any> => {
	// console.log(body, '------------->');
	try {
		const response = await fetchHandlerForm({
			method: 'POST',
			endpoint: '/plan',
			body,
		});
		if (response) {
			return response;
		}
	} catch (error) {
		console.error('errror showing', error);
		throw error;
	}
};
export const updatePlan = async (body: any, id: string): Promise<any> => {
	// console.log(body, '------------->');
	try {
		const response = await fetchHandlerForm({
			method: 'PATCH',
			endpoint: `/plan/${id}`,
			body,
		});
		if (response) {
			return response;
		}
	} catch (error) {
		console.error('errror showing', error);
		throw error;
	}
};
export const updatePlanStatus = async (body: any, id: string): Promise<any> => {
	// console.log(body, '------------->');
	try {
		const response = await fetchHandler({
			method: 'PATCH',
			endpoint: `/plan/updateplanstatus/${id}`,
			// updateplanstatus/:id
			data: body,
		});
		if (response) {
			return response;
		}
	} catch (error) {
		console.error('errror showing', error);
		throw error;
	}
};

export const getPlanField = async (id: string): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `plan/plan-structures/${id}`, // Replace with your actual API endpoint
		});
		return response;
	} catch (error) {
		console.error('Error fetching blogs:', error);
		throw new Error('Could not fetch blogs. Please try again later.');
	}
};
export const getPlan = async (id: string): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `/plan/${id}`, // Replace with your actual API endpoint
		});
		return response;
	} catch (error) {
		console.error('Error fetching blogs:', error);
		throw new Error('Could not fetch blogs. Please try again later.');
	}
};

export const createPlanOTT = async (body: any): Promise<any> => {
	// console.log(body, '------------->');
	try {
		const response = await fetchHandlerForm({
			method: 'POST',
			endpoint: '/plan/plan-structures',
			body,
		});
		if (response) {
			return response;
		}
	} catch (error) {
		console.error('errror showing', error);
		throw error;
	}
};
